var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect } from "react";
import "../MutualFundsStyleSheet/SyncedClientsTab.scss";
import SearchPanelWithPopupFiltersLabel from "@frameworks/shared-library/components/SearchPanelWithPopupFiltersLabel/SearchPanelWithPopupFiltersLabel";
import VerticalFilterTabs from "@frameworks/shared-library/components/VerticalFilterTabs/VerticalFilterTabs";
import { EFilterValues, EScreenState, syncNowCheckBoxDetails, } from "@frameworks/arn-transfer/constants/constant";
import GenericCheckbox from "@frameworks/shared-library/components/GenericCheckbox/GenericCheckbox";
import { generateClientTierIcon } from "@frameworks/shared-library/components/TransactionJourney/MutualFund/MutualFundConstant";
import DynamicPagination from "@frameworks/shared-library/components/Pagination/Pagination";
import GenericTable from "@frameworks/shared-library/components/GenericTable";
import GenericSchemeName from "@frameworks/shared-library/components/GenericSchemeName/GenericSchemeName";
import { alphabetsColorsConfigMap } from "@frameworks/shared-library/components/TextFirstAlphabetAsIcon/colorConfigurationsForTextFirstAlphabetAsIcon";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import { Overlay, Popover } from "react-bootstrap";
import RadioButton from "@frameworks/shared-library/components/RadioButton/RadioButton";
import { getArnSyncClientTabDetails, } from "@frameworks/arn-transfer/api/ArnSyncClient";
import { ETransferInClientTabs } from "../MFTransfer";
import moment from "moment";
import Errormsg from "@frameworks/shared-library/components/errorMsg";
import noResultsFound from "@frameworks/shared-library/assets/images/markets/noResultsFound.svg";
import { ESortOrder } from "@domains/features/Markets/MutualFunds/dto/MutualFundsSchemesDTO";
import GenericTableShimmer from "@frameworks/shared-library/components/GenericTableShimmer/GenericTableShimmer";
import GenericSidebar from "@frameworks/shared-library/components/GenericSidebar";
import SidebarHeader from "../Sidebar/SidebarHeader";
import MFCentralSidebarBody from "../Sidebar/MFCentralSidebarBody";
import MFCentralSidebarFooter from "../Sidebar/MFCentralSidebarFooter";
import { getMfCenterOtp, } from "@frameworks/arn-transfer/api/MfCenterOtp";
import { getMfCenterData } from "@frameworks/arn-transfer/api/MfCenterData";
import ConfirmationPopup from "@frameworks/shared-library/components/ConfirmationPopup/ConfirmationPopup";
import PopupConfirmation from "@frameworks/shared-library/components/Offerings/Generic/PopUpConfirmation/PopUpConfirmation";
import schemeNotAvailable from "@frameworks/shared-library/assets/images/SalesJourney/schemeNotAvailable.svg";
import { useNavigate } from "react-router-dom";
import { getArnFiltersData, } from "@frameworks/arn-transfer/api/ArnFilters";
var SyncedClientsTab = function () {
    var navigate = useNavigate();
    var _a = __read(useState(false), 2), isShowFilterPopup = _a[0], setIsShowFilterPopup = _a[1];
    var _b = __read(useState(), 2), currentFilterState = _b[0], setCurrentFilterState = _b[1];
    var _c = __read(useState(), 2), finalFilterState = _c[0], setFinalFilterState = _c[1];
    var _d = __read(useState({ isShowPopup: false, containerId: "" }), 2), tableSyncActionConfig = _d[0], setTableSyncActionConfig = _d[1];
    var _e = __read(useState(false), 2), transferInPopup = _e[0], setTransferInPopup = _e[1];
    var _f = __read(useState(""), 2), seletedCheckBox = _f[0], setSeletedCheckBox = _f[1];
    var _g = __read(useState(false), 2), openSidebar = _g[0], setOpenSidebar = _g[1];
    var _h = __read(useState([]), 2), tableData = _h[0], setTableData = _h[1];
    var _j = __read(useState(false), 2), tableLoader = _j[0], setTableLoader = _j[1];
    var _k = __read(useState({ type: ESortOrder.DESCENDING, sortKey: "ac_name" }), 2), sortType = _k[0], setSortType = _k[1];
    var _l = __read(useState(), 2), clientInfoToBeSynced = _l[0], setClientInfoToBeSynced = _l[1];
    var _m = __read(useState(""), 2), mobileNumber = _m[0], setMobileNumber = _m[1];
    var _o = __read(useState(false), 2), isShowOtpField = _o[0], setIsShowOtpField = _o[1];
    var _p = __read(useState(false), 2), otpTimer = _p[0], setOtpTimer = _p[1];
    var _q = __read(useState(""), 2), otp = _q[0], setOtp = _q[1];
    var _r = __read(useState(""), 2), isOtpError = _r[0], setIsOtpError = _r[1];
    var _s = __read(useState(false), 2), isReadyToProceed = _s[0], setIsReadyToProceed = _s[1];
    var _t = __read(useState(EScreenState.GENERATE_OTP), 2), currentScreen = _t[0], setCurrentScreen = _t[1];
    var _u = __read(useState(), 2), genereateOtpData = _u[0], setGenereateOtpData = _u[1];
    var _v = __read(useState(false), 2), sidebarBodyLoader = _v[0], setSidebarBodyLoader = _v[1];
    var _w = __read(useState(false), 2), inputDisabled = _w[0], setInputDisabled = _w[1];
    var _x = __read(useState(""), 2), mobileFieldError = _x[0], setMobileFieldError = _x[1];
    var _y = __read(useState({
        clientTier: [],
        investmentValue: [],
    }), 2), filterData = _y[0], setFilterData = _y[1];
    var _z = __read(useState(""), 2), searchText = _z[0], setSearchText = _z[1];
    var handleActionClick = function (details, isForSyncAgain) {
        if (isForSyncAgain === void 0) { isForSyncAgain = true; }
        setMobileNumber(details === null || details === void 0 ? void 0 : details.mobileno);
        if (isForSyncAgain) {
            setTableSyncActionConfig(function (prev) {
                var updatedState = {
                    isShowPopup: (prev === null || prev === void 0 ? void 0 : prev.containerId) === ""
                        ? true
                        : (prev === null || prev === void 0 ? void 0 : prev.containerId) === (details === null || details === void 0 ? void 0 : details.pan) && (prev === null || prev === void 0 ? void 0 : prev.isShowPopup)
                            ? false
                            : true,
                    containerId: details === null || details === void 0 ? void 0 : details.pan,
                };
                return updatedState;
            });
        }
        else {
            if (!!(details === null || details === void 0 ? void 0 : details.is_3mthago)) {
                setTransferInPopup(true);
            }
            else {
                navigate("/dashboard/mf-transfer/transfer-in?details=".concat(btoa(JSON.stringify(details))), { replace: true });
            }
        }
        setClientInfoToBeSynced(details);
    };
    var actionBlock = function (params) {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { id: params === null || params === void 0 ? void 0 : params.pan, className: "sync-now-btn txt-tomato flexCenter hand_cursor w-100", onClick: function () {
                    handleActionClick(params, true);
                } },
                React.createElement("span", { className: "me-2 text-nowrap DMSan_14_500" }, "Sync Again"),
                React.createElement("span", { className: "bg_light-salmon-pink" }),
                React.createElement("span", { className: "ms-2 d-flex icon-tap" }, (tableSyncActionConfig === null || tableSyncActionConfig === void 0 ? void 0 : tableSyncActionConfig.isShowPopup) &&
                    (tableSyncActionConfig === null || tableSyncActionConfig === void 0 ? void 0 : tableSyncActionConfig.containerId) === (params === null || params === void 0 ? void 0 : params.pan) ? (React.createElement("i", { className: "edel-icon-arrow-up-thin" })) : (React.createElement("i", { className: "edel-icon-arrow-down" })))),
            React.createElement(EdButton, { btnTyp: "tomato-filled-rounded", value: "Transfer-In", type: "button", className: "w-100 transfer-in text-nowrap", onClick: function () {
                    handleActionClick(params, false);
                }, disabled: (params === null || params === void 0 ? void 0 : params.is_transferin) ? false : true })));
    };
    var syncedClientsTabColumn = [
        {
            columnName: "Client Name/PAN",
            sortKey: "ac_name",
            arrows: true,
            columnClassName: "",
            applySorting: true,
            keysForCustomFunction: ["ac_name", "pan", "client_tier"],
            tdCustomFunction: function (keys) {
                var _a;
                return (React.createElement(GenericSchemeName, { name: keys[0], subText1: keys === null || keys === void 0 ? void 0 : keys[1], badgeIcon: generateClientTierIcon(keys[2]), showImage: true, parentClassName: (_a = keys[2]) === null || _a === void 0 ? void 0 : _a.toLowerCase(), textAndBackgroundColorCollectionConfig: alphabetsColorsConfigMap, maxWidth: 305, showTooltip: true }));
            },
        },
        {
            columnName: "External Investment Value (₹)",
            key: "inv_amt",
            sortKey: "inv_amt",
            arrows: true,
            columnClassName: "text-end",
            applySorting: true,
            arrowClassName: "justify-content-end",
            tdCustomFunction: function (key) { return (React.createElement("div", { className: "d-flex flex-column gap-1" },
                React.createElement("span", { className: "RobotoM_14_500" }, key))); },
        },
        {
            columnName: "Folio No.",
            key: "folio_no",
            sortKey: "folio_no",
            arrows: true,
            columnClassName: "text-end",
            applySorting: true,
            arrowClassName: "justify-content-end",
        },
        {
            columnName: "Last Synced",
            sortKey: "last_sync_date",
            arrows: true,
            columnClassName: "text-end",
            applySorting: true,
            keysForCustomFunction: [
                "last_sync_date",
                "ac_name",
                "pan",
                "ucccode",
                "ac_code",
                "folio_no",
                "isin_code",
                "isDownload",
                "sync_id",
                "arnStatus",
                "mobileno",
            ],
            arrowClassName: "justify-content-end",
            tdCustomFunction: function (keys) {
                return (React.createElement("div", null,
                    React.createElement("div", null, moment(keys[0]).format("DD MMM YYYY")),
                    React.createElement("div", { className: "txt-hanBlue mt-1 text-decoration-underline DMSanN_14_400 hand_cursor", onClick: function () {
                            navigate("profile-history", {
                                state: {
                                    selectedDetails: {
                                        last_sync_date: keys[0],
                                        ac_name: keys[1],
                                        pan: keys[2],
                                        ucccode: keys[3],
                                        ac_code: keys[4],
                                        folio_no: keys[5],
                                        isin_code: keys[6],
                                        isDownload: keys[7],
                                        sync_id: keys[8],
                                        arnStatus: keys[9],
                                        mobileno: keys[10],
                                    },
                                },
                            });
                        } }, "View History")));
            },
        },
        {
            columnName: "Actions",
            arrows: false,
            columnClassName: "text-start",
            applySorting: false,
            keysForCustomFunction: [
                "pan",
                "mobileno",
                "email",
                "ucccode",
                "ac_name",
                "client_tier",
                "sync_id",
                "is_3mthago",
                "ac_code",
                "is_transferin",
                "last_sync_date",
            ],
            tdCustomFunction: function (_a) {
                var _b = __read(_a, 11), pan = _b[0], mobileno = _b[1], email = _b[2], ucccode = _b[3], ac_name = _b[4], client_tier = _b[5], sync_id = _b[6], is_3mthago = _b[7], ac_code = _b[8], is_transferin = _b[9], last_sync_date = _b[10];
                return actionBlock({
                    pan: pan,
                    mobileno: mobileno,
                    email: email,
                    ucccode: ucccode,
                    ac_name: ac_name,
                    client_tier: client_tier,
                    sync_id: sync_id,
                    is_3mthago: is_3mthago,
                    ac_code: ac_code,
                    is_transferin: is_transferin,
                    last_sync_date: last_sync_date,
                });
            },
        },
    ];
    var handleSetFilterState = function (key, value) {
        setCurrentFilterState(function (prev) {
            var _a;
            var prevState = prev || {};
            var existingValues = prevState[key] || [];
            var exists = existingValues.some(function (v) { return v.Id === value.Id; });
            var updatedValues = exists
                ? existingValues.filter(function (v) { return v.Id !== value.Id; })
                : __spreadArray(__spreadArray([], __read(existingValues), false), [value], false);
            return __assign(__assign({}, prevState), (_a = {}, _a[key] = updatedValues, _a));
        });
    };
    var generateClientTierFilterTabContent = function () {
        var _a;
        return (React.createElement("div", { className: "client-tier-filters" }, (_a = filterData === null || filterData === void 0 ? void 0 : filterData.clientTier) === null || _a === void 0 ? void 0 : _a.map(function (item) {
            var _a;
            return (React.createElement("div", { key: item.Id, className: "cursor-pointer", onClick: function () {
                    handleSetFilterState("clientTier", item);
                } },
                React.createElement(GenericCheckbox, { checkboxType: "han-blue", parentClassName: "cursor-pointer", checkboxProps: {
                        checked: !!((_a = currentFilterState === null || currentFilterState === void 0 ? void 0 : currentFilterState.clientTier) === null || _a === void 0 ? void 0 : _a.some(function (tierItem) { return tierItem.Id === item.Id; })),
                        value: item.Name,
                        name: "client_tier",
                    }, customLabel: React.createElement("label", { className: "client-tier-filter-label cursor-pointer" },
                        React.createElement("span", { className: "txt-han-blue DMSansNormal_12_400" }, item === null || item === void 0 ? void 0 : item.Name),
                        React.createElement("span", null,
                            React.createElement("img", { src: generateClientTierIcon(item === null || item === void 0 ? void 0 : item.Name), alt: item === null || item === void 0 ? void 0 : item.Name }))) })));
        })));
    };
    var generateInvestmentValueFilterTabContent = function () {
        var _a;
        return (React.createElement("div", { className: "client-tier-filters" }, (_a = filterData === null || filterData === void 0 ? void 0 : filterData.investmentValue) === null || _a === void 0 ? void 0 : _a.map(function (item) {
            var _a;
            return (React.createElement("div", { key: item.Id, className: "cursor-pointer", onClick: function () {
                    handleSetFilterState("investmentValue", item);
                } },
                React.createElement(GenericCheckbox, { checkboxType: "han-blue", parentClassName: "cursor-pointer", checkboxProps: {
                        checked: !!((_a = currentFilterState === null || currentFilterState === void 0 ? void 0 : currentFilterState.investmentValue) === null || _a === void 0 ? void 0 : _a.some(function (invItem) { return invItem.Id === item.Id; })),
                        value: item.Name,
                        name: "investment_value",
                    }, labelProps: {
                        children: item.Name,
                        className: "DMSansNormal_12_400",
                    } })));
        })));
    };
    var syncedClientFilterTabs = [
        {
            eventKey: EFilterValues.CLIENT_TIER,
            title: "Client Tier",
            tabContent: generateClientTierFilterTabContent(),
        },
        {
            eventKey: EFilterValues.INVESTMENT_VALUE,
            title: "Investment Value",
            tabContent: generateInvestmentValueFilterTabContent(),
        },
    ];
    var handleCallbackSort = function (e) {
        getSyncClientTableData({ orderby: e.sortKey, orderbydesc: !e.type });
        setSortType(function () { return ({
            type: e.type ? ESortOrder.ASCENDING : ESortOrder.DESCENDING,
            sortKey: e.sortKey,
        }); });
    };
    var getSyncClientTableData = function (params) {
        var _a, _b, _c, _d, _e, _f;
        setTableLoader(true);
        var payload = {
            searchValue: (_a = params === null || params === void 0 ? void 0 : params.searchValue) !== null && _a !== void 0 ? _a : searchText,
            tabId: Number(ETransferInClientTabs.SYNCED_CLIENTS),
            clientTierId: (params === null || params === void 0 ? void 0 : params.clientTierId)
                ? params === null || params === void 0 ? void 0 : params.clientTierId
                : ((_c = (_b = finalFilterState === null || finalFilterState === void 0 ? void 0 : finalFilterState.clientTier) === null || _b === void 0 ? void 0 : _b.map(function (item) { return item.Id; })) === null || _c === void 0 ? void 0 : _c.filter(function (id) { return id != null && id !== undefined; }).join(",")) || "",
            investmentValueId: (params === null || params === void 0 ? void 0 : params.investmentValueId)
                ? params === null || params === void 0 ? void 0 : params.investmentValueId
                : ((_e = (_d = finalFilterState === null || finalFilterState === void 0 ? void 0 : finalFilterState.investmentValue) === null || _d === void 0 ? void 0 : _d.map(function (item) { return item.Id; })) === null || _e === void 0 ? void 0 : _e.filter(function (id) { return id != null && id !== undefined; }).join(",")) || "",
            sync_id: 0,
            uccCode: "",
            page_index: 1,
            page_size: 100,
            orderbydesc: !!(params === null || params === void 0 ? void 0 : params.orderbydesc),
            orderby: (_f = params === null || params === void 0 ? void 0 : params.orderby) !== null && _f !== void 0 ? _f : "",
        };
        getArnSyncClientTabDetails(payload)
            .then(function (resp) {
            setTableData(resp === null || resp === void 0 ? void 0 : resp.data);
            setTableLoader(false);
        })
            .catch(function (err) {
            setTableLoader(false);
        });
    };
    var getMfCenterOtpData = function () {
        setSidebarBodyLoader(true);
        getMfCenterOtp({
            email: clientInfoToBeSynced === null || clientInfoToBeSynced === void 0 ? void 0 : clientInfoToBeSynced.email,
            mobile: mobileNumber,
            pan: clientInfoToBeSynced === null || clientInfoToBeSynced === void 0 ? void 0 : clientInfoToBeSynced.pan,
            uccCode: clientInfoToBeSynced === null || clientInfoToBeSynced === void 0 ? void 0 : clientInfoToBeSynced.ucccode,
            syncId: 0,
        })
            .then(function (resp) {
            if (resp === null || resp === void 0 ? void 0 : resp.data) {
                setGenereateOtpData(resp === null || resp === void 0 ? void 0 : resp.data);
                setIsShowOtpField(true);
                setOtpTimer(true);
                setMobileFieldError("");
                setInputDisabled(true);
            }
            setSidebarBodyLoader(false);
        })
            .catch(function (err) {
            setSidebarBodyLoader(false);
            setMobileFieldError("Invalid PAN/PEKRN, Mobile/Email combination");
        });
    };
    var getMfCenterDataToProcced = function () {
        setSidebarBodyLoader(true);
        setIsReadyToProceed(false);
        getMfCenterData({
            id: genereateOtpData === null || genereateOtpData === void 0 ? void 0 : genereateOtpData.id,
            reqId: genereateOtpData === null || genereateOtpData === void 0 ? void 0 : genereateOtpData.reqId,
            otpRef: genereateOtpData === null || genereateOtpData === void 0 ? void 0 : genereateOtpData.otpRef,
            userSubjectReference: genereateOtpData === null || genereateOtpData === void 0 ? void 0 : genereateOtpData.userSubjectReference,
            clientRefNo: genereateOtpData === null || genereateOtpData === void 0 ? void 0 : genereateOtpData.clientRefNo,
            enteredOtp: otp,
            uccCode: clientInfoToBeSynced === null || clientInfoToBeSynced === void 0 ? void 0 : clientInfoToBeSynced.ucccode,
        })
            .then(function (resp) {
            var _a, _b, _c, _d, _e;
            if ((resp === null || resp === void 0 ? void 0 : resp.data) && ((_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.isSuccess)) {
                setClientInfoToBeSynced(function (prev) {
                    var updatedData = __assign(__assign({}, prev), { sync_id: genereateOtpData === null || genereateOtpData === void 0 ? void 0 : genereateOtpData.id });
                    return updatedData;
                });
                setCurrentScreen(EScreenState.SYNC_SUCCESS);
            }
            else if (((_c = (_b = resp === null || resp === void 0 ? void 0 : resp.errors) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.code) === "406") {
                setIsOtpError((_e = (_d = resp === null || resp === void 0 ? void 0 : resp.errors) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.message);
                setIsReadyToProceed(false);
            }
            else
                setCurrentScreen(EScreenState.SYNC_FAILURE);
            setSidebarBodyLoader(false);
        })
            .catch(function (error) {
            setCurrentScreen(EScreenState.SYNC_FAILURE);
            setSidebarBodyLoader(false);
        });
    };
    var getArnFiltersDetails = function (params) {
        var _a;
        getArnFiltersData({
            search_text: (_a = params === null || params === void 0 ? void 0 : params.search_text) !== null && _a !== void 0 ? _a : EFilterValues.CLIENT_TIER,
        })
            .then(function (resp) {
            if (resp === null || resp === void 0 ? void 0 : resp.data) {
                setFilterData(function (prev) {
                    var _a, _b, _c, _d, _e, _f;
                    var updatedData = {
                        clientTier: ((_b = (_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.clientTier) === null || _b === void 0 ? void 0 : _b.length) > 0
                            ? (_c = resp === null || resp === void 0 ? void 0 : resp.data) === null || _c === void 0 ? void 0 : _c.clientTier
                            : prev === null || prev === void 0 ? void 0 : prev.clientTier,
                        investmentValue: ((_e = (_d = resp === null || resp === void 0 ? void 0 : resp.data) === null || _d === void 0 ? void 0 : _d.investmentValue) === null || _e === void 0 ? void 0 : _e.length) > 0
                            ? (_f = resp === null || resp === void 0 ? void 0 : resp.data) === null || _f === void 0 ? void 0 : _f.investmentValue
                            : prev === null || prev === void 0 ? void 0 : prev.investmentValue,
                    };
                    return updatedData;
                });
            }
        })
            .catch(function (err) { });
    };
    var handleApplyBtnClick = function () {
        var _a, _b, _c, _d;
        setFinalFilterState(currentFilterState);
        getSyncClientTableData({
            clientTierId: ((_b = (_a = currentFilterState === null || currentFilterState === void 0 ? void 0 : currentFilterState.clientTier) === null || _a === void 0 ? void 0 : _a.map(function (item) { return item.Id; })) === null || _b === void 0 ? void 0 : _b.filter(function (id) { return id != null && id !== undefined; }).join(",")) || "",
            investmentValueId: ((_d = (_c = currentFilterState === null || currentFilterState === void 0 ? void 0 : currentFilterState.investmentValue) === null || _c === void 0 ? void 0 : _c.map(function (item) { return item.Id; })) === null || _d === void 0 ? void 0 : _d.filter(function (id) { return id != null && id !== undefined; }).join(",")) || "",
        });
        setIsShowFilterPopup(false);
    };
    useEffect(function () {
        getSyncClientTableData();
        getArnFiltersDetails({ search_text: EFilterValues.CLIENT_TIER });
        getArnFiltersDetails({ search_text: EFilterValues.INVESTMENT_VALUE });
    }, []);
    return (React.createElement("div", { className: "synced-clients-tab-content" },
        React.createElement("span", { className: "DMSansBold_25_700 txt-midnight-blue" }, "Synced Clients"),
        React.createElement(SearchPanelWithPopupFiltersLabel, { parentClassName: "synced-clients-search-pannel", searchBarParentClassName: "w-400", placeholder: "Search by Client Name/UCC/PAN...", applySearchedFilters: function (e) {
                setSearchText(e);
                getSyncClientTableData({ searchValue: e });
            }, isShowPopup: isShowFilterPopup, setIsShowPopup: setIsShowFilterPopup, delay: 400, autoComplete: "off", filterComponentInsidePopup: React.createElement(VerticalFilterTabs, { parentClassName: "synced-clients-filter-popup", tabsList: syncedClientFilterTabs, applyBtnCallback: function () {
                    handleApplyBtnClick();
                }, clearAllBtnCallback: function () {
                    setCurrentFilterState({ clientTier: [], investmentValue: [] });
                    setFinalFilterState({ clientTier: [], investmentValue: [] });
                    getSyncClientTableData({
                        clientTierId: "",
                        investmentValueId: "",
                    });
                    setIsShowFilterPopup(false);
                }, cancelBtnCallback: function () {
                    setIsShowFilterPopup(false);
                } }) }),
        tableLoader && (React.createElement(GenericTableShimmer, { rowCount: 10, columnCount: 5, columnsWidthClass: "table-shimmer-col-fr2-1-1-1-2" })),
        (tableData === null || tableData === void 0 ? void 0 : tableData.length) > 0 ? (React.createElement(DynamicPagination, { dataLengthPerPage: 10, data: tableData, Bodycomponent: GenericTable, rowClassName: "", columns: syncedClientsTabColumn, parentClassName: "transfer-in-synced-clients-tab-table", infinityScroll: true, paginationLoader: tableLoader, callbackSorted: function (e) {
                handleCallbackSort(e);
            }, sortIconUp: "edel-icon-arrow-up-thin", sortIconDown: "edel-icon-arrow-down", viewAll: true, isPageFromParent: true, selectedSortVal: sortType.type, selectedSortColumnVal: sortType.sortKey })) : (React.createElement("div", { className: "custom-error-state" },
            React.createElement(Errormsg, { image: noResultsFound, msg: "No Client Found" }))),
        openSidebar && (React.createElement(GenericSidebar, { parentClassname: "arn-transfer-all-client-sidebar", blurBackground: true, header: React.createElement(SidebarHeader, { title: "MF Central", description: "Sync MF holdings. Client OTP required.", iconClass: "edel-icon-cloud" }), body: React.createElement(MFCentralSidebarBody, { mobileNumber: mobileNumber, setMobileNumber: setMobileNumber, isShowOtpField: isShowOtpField, setIsShowOtpField: setIsShowOtpField, otp: otp, setOtp: setOtp, otpTimer: otpTimer, setOtpTimer: setOtpTimer, isOtpError: isOtpError, setIsOtpError: setIsOtpError, currentScreen: currentScreen, setCurrentScreen: setCurrentScreen, isReadyToProceed: isReadyToProceed, setIsReadyToProceed: setIsReadyToProceed, clientInfoToBeSynced: clientInfoToBeSynced, getMfCenterOtpData: getMfCenterOtpData, sidebarBodyLoader: sidebarBodyLoader, inputDisabled: inputDisabled, mobileFieldError: mobileFieldError }), footer: React.createElement(MFCentralSidebarFooter, { isReadyToProceed: isReadyToProceed, setIsReadyToProceed: setIsReadyToProceed, currentScreen: currentScreen, setCurrentScreen: setCurrentScreen, setOpenSidebar: setOpenSidebar, getMfCenterDataToProcced: getMfCenterDataToProcced, setOtpTimer: setOtpTimer, setIsShowOtpField: setIsShowOtpField, setInputDisabled: setInputDisabled, clientInfoToBeSynced: clientInfoToBeSynced, setMobileFieldError: setMobileFieldError, setIsOtpError: setIsOtpError }), openKey: openSidebar, setOpenKey: function (e) {
                if (e === false) {
                    setOpenSidebar(e);
                    setCurrentScreen(EScreenState.GENERATE_OTP);
                    setIsReadyToProceed(false);
                    setIsShowOtpField(false);
                    setOtpTimer(false);
                    setInputDisabled(false);
                    setMobileFieldError("");
                    setIsOtpError("");
                }
            }, arrowClose: true, delay: 10, dontCloseOnOutsideClick: true })),
        (tableSyncActionConfig === null || tableSyncActionConfig === void 0 ? void 0 : tableSyncActionConfig.isShowPopup) && (React.createElement(Overlay, { onHide: function (e) {
                setTableSyncActionConfig(function (prev) { return (__assign(__assign({}, prev), { isShowPopup: false })); });
                setSeletedCheckBox("");
            }, show: true, target: document.getElementById(tableSyncActionConfig.containerId), rootClose: true, rootCloseEvent: "click", placement: "bottom-end", container: document.getElementById(tableSyncActionConfig.containerId) },
            React.createElement(Popover, { id: "popover-contained", className: "sync-now-popup removePopupTooltipArrow", style: { position: "fixed" } },
                React.createElement(Popover.Body, null, syncNowCheckBoxDetails === null || syncNowCheckBoxDetails === void 0 ? void 0 : syncNowCheckBoxDetails.map(function (val, idx) {
                    var _a, _b;
                    return (React.createElement("div", { className: "d-flex gap-2 single-sync ".concat(((_a = val === null || val === void 0 ? void 0 : val.item) === null || _a === void 0 ? void 0 : _a.value) === seletedCheckBox && "bg-ghost-white3"), key: idx, onClick: function () {
                            var _a;
                            setSeletedCheckBox((_a = val === null || val === void 0 ? void 0 : val.item) === null || _a === void 0 ? void 0 : _a.value);
                            setOpenSidebar(true);
                        } },
                        React.createElement("div", null,
                            React.createElement(RadioButton, { name: "sync-now-radio", list: val === null || val === void 0 ? void 0 : val.item, key: idx, selected: seletedCheckBox, onChange: function (e) {
                                    setSeletedCheckBox(e.target.value);
                                    setOpenSidebar(true);
                                } })),
                        React.createElement("div", { className: "d-flex flex-column gap-2" },
                            React.createElement("span", { className: "DMSanN_14_400 txt-purpleFog" }, (_b = val === null || val === void 0 ? void 0 : val.item) === null || _b === void 0 ? void 0 : _b.display),
                            React.createElement("span", { className: "DMsanR_12_300 txt_manatee" }, val === null || val === void 0 ? void 0 : val.desc),
                            React.createElement("span", { className: "DMsanR_10_400 txt_secondary-gray d-flex align-items-center" },
                                React.createElement("i", { className: "edel-icon-refresh-stroke me-1" }),
                                "Last synced:",
                                " ",
                                (clientInfoToBeSynced === null || clientInfoToBeSynced === void 0 ? void 0 : clientInfoToBeSynced.last_sync_date)
                                    ? moment(clientInfoToBeSynced === null || clientInfoToBeSynced === void 0 ? void 0 : clientInfoToBeSynced.last_sync_date).format("DD MMM YYYY")
                                    : "-"))));
                }))))),
        transferInPopup && (React.createElement(ConfirmationPopup, { show: true, popTitle: "transfer-in-pop", showFooter: false, popupClass: "", isShowHeader: false },
            React.createElement(PopupConfirmation, { onFirsBtnClick: function () {
                    navigate("/dashboard/mf-transfer/transfer-in?details=".concat(btoa(JSON.stringify(clientInfoToBeSynced))), { replace: true });
                }, onClose: function () {
                    setTransferInPopup(false);
                }, onSecondBtnClick: function () {
                    setTransferInPopup(false);
                    setOpenSidebar(true);
                }, message: "Sync Your Data", description: "It’s been 3 months since your last sync. Do you want to sync now before transferring?", confirmationImageSrc: schemeNotAvailable, buttonFirstTitle: "Continue Transfer In", buttonSecTitle: "Sync Now" })))));
};
export default SyncedClientsTab;
